module.exports = __webpack_public_path__ + "static/media/style-empty.d3fd54ff.svg";